// The access keys Sheets shows after menu items ("값만(V)"), by "parent > item" as its Korean menus have them
// (recorded from Google Sheets: analysis/10-google-menus.json, 12-google-context.json). The top menu is the parent of
// its own items.
export const MNEMONICS: Record<string, string> = {
  "AppSheet > 샘플 앱 보기": "V",
  "AppSheet > 앱 만드는 방법 알아보기": "L",
  "AppSheet > 앱 만들기": "C",
  "계산 관리 > 수동": "M",
  "계산 관리 > 자동": "A",
  "고정 > 1행까지": "U",
  "고정 > A열까지": "P",
  "고정 > 열 1개": "L",
  "고정 > 열 2개": "M",
  "고정 > 열 고정 없음": "C",
  "고정 > 행 1개": "O",
  "고정 > 행 2개": "W",
  "고정 > 행 고정 없음": "R",
  "공유 > 다른 사용자와 공유": "S",
  "공유 > 웹에 게시": "W",
  "그룹 > 그룹해제": "U",
  "그룹 > 그룹화": "G",
  "글꼴 크기 > 10": "5",
  "글꼴 크기 > 11": "6",
  "글꼴 크기 > 12": "7",
  "글꼴 크기 > 14": "8",
  "글꼴 크기 > 18": "9",
  "글꼴 크기 > 24": "0",
  "글꼴 크기 > 36": "T",
  "글꼴 크기 > 6": "1",
  "글꼴 크기 > 7": "2",
  "글꼴 크기 > 8": "3",
  "글꼴 크기 > 9": "4",
  "다운로드 > 웹페이지(.html)": "W",
  "댓글 > 댓글 숨기기": "5",
  "댓글 > 댓글 최소화": "7",
  "댓글 > 모든 댓글 보기": "6",
  "데이터 > 그룹화 보기 만들기": "T",
  "데이터 > 데이터 분석": "G",
  "데이터 > 데이터 정리": "U",
  "데이터 > 데이터 추출": "X",
  "데이터 > 데이터 확인": "V",
  "데이터 > 범위 임의로 섞기": "D",
  "데이터 > 범위 정렬": "R",
  "데이터 > 슬라이서 추가": "J",
  "데이터 > 시트 및 범위 보호": "O",
  "데이터 > 시트 정렬": "S",
  "데이터 > 열 통계": "L",
  "데이터 > 이름이 지정된 범위": "N",
  "데이터 > 이름이 지정된 함수": "K",
  "데이터 > 최적화 문제 풀이": "M",
  "데이터 > 텍스트를 열로 분할": "E",
  "데이터 > 필터 만들기": "F",
  "데이터 > 필터 보기 만들기": "P",
  "데이터 스튜디오 > 보고서 만드는 방법 알아보기": "L",
  "데이터 스튜디오 > 보고서 생성": "C",
  "데이터 스튜디오 > 샘플 보고서 보기": "V",
  "데이터 정리 > 공백 제거": "I",
  "데이터 정리 > 정리 제안사항": "Y",
  "데이터 정리 > 중복 항목 삭제": "M",
  "데이터 커넥터 > 새로고침 옵션": "R",
  "도구 > 계산 관리": "B",
  "도구 > 맞춤법 검사": "S",
  "도구 > 새 양식 만들기": "F",
  "도구 > 알림 설정": "N",
  "도구 > 접근성": "C",
  "도구 > 추천 컨트롤": "G",
  "도움말 > Sheets 개선 돕기": "R",
  "도움말 > 개인정보처리방침": "P",
  "도움말 > 교육": "T",
  "도움말 > 메뉴 검색": "M",
  "도움말 > 서비스 약관": "S",
  "도움말 > 스프레드시트 도움말": "H",
  "도움말 > 업데이트": "U",
  "도움말 > 키보드 단축키": "K",
  "도움말 > 함수 목록": "F",
  "맞춤 각도 > -15°": "6",
  "맞춤 각도 > -30°": "5",
  "맞춤 각도 > -60°": "3",
  "맞춤 각도 > -75°": "2",
  "맞춤 각도 > -90°": "1",
  "맞춤 각도 > 0°": "7",
  "맞춤 각도 > 15°": "8",
  "맞춤 각도 > 30°": "9",
  "맞춤 각도 > 45°": "A",
  "맞춤 각도 > 60°": "B",
  "맞춤 각도 > 75°": "C",
  "맞춤 각도 > 90°": "D",
  "맞춤법 검사 > 개인 사전": "C",
  "맞춤법 검사 > 맞춤법 검사": "S",
  "매크로 > 매크로 가져오기": "I",
  "매크로 > 매크로 관리": "M",
  "매크로 > 매크로 기록": "R",
  "버전 기록 > 버전 기록 보기": "S",
  "버전 기록 > 현재 버전 이름 지정": "N",
  "보기 > 고정": "R",
  "보기 > 그룹": "G",
  "보기 > 댓글": "4",
  "보기 > 숨겨진 시트": "H",
  "보기 > 전체 화면": "U",
  "보기 > 표시": "S",
  "보기 > 확대/축소": "Z",
  "부가기능 > 문서 부가기능 보기": "A",
  "부가기능 > 부가기능 관리": "M",
  "부가기능 > 부가기능 설치하기": "G",
  "삭제 > 1행 삭제": "D",
  "삭제 > A열 삭제": "E",
  "삭제 > 값": "V",
  "삭제 > 셀을 삭제하고 기존 셀을 왼쪽으로 이동": "Z",
  "삭제 > 셀을 삭제하고 기존 셀을 위쪽으로 이동": "Y",
  "삭제 > 참고": "L",
  "삽입 > 그림 이모티콘": "E",
  "삽입 > 그림": "W",
  "삽입 > 댓글": "M",
  "삽입 > 드롭다운": "D",
  "삽입 > 링크": "K",
  "삽입 > 메모": "N",
  "삽입 > 사전 빌드된 테이블": "B",
  "삽입 > 셀": "L",
  "삽입 > 스마트 칩": "A",
  "삽입 > 시트": "S",
  "삽입 > 열": "C",
  "삽입 > 이미지": "G",
  "삽입 > 차트": "H",
  "삽입 > 체크박스": "X",
  "삽입 > 표 생성": "V",
  "삽입 > 피봇 테이블": "P",
  "삽입 > 함수": "U",
  "삽입 > 행": "R",
  "새 문서 > 스프레드시트": "S",
  "새 문서 > 템플릿 갤러리에서": "T",
  "새 문서 > 표 생성": "V",
  "서식 > 교차 색상": "L",
  "서식 > 글꼴 크기": "S",
  "서식 > 서식 지우기": "C",
  "서식 > 셀 병합": "M",
  "서식 > 숫자": "N",
  "서식 > 스마트 칩": "P",
  "서식 > 정렬": "A",
  "서식 > 조건부 서식": "F",
  "서식 > 줄바꿈": "W",
  "서식 > 테마": "T",
  "서식 > 텍스트": "X",
  "서식 > 표로 변환": "E",
  "서식 > 회전": "R",
  "선택하여 붙여넣기 > 값만": "V",
  "선택하여 붙여넣기 > 데이터 확인만": "D",
  "선택하여 붙여넣기 > 서식만": "T",
  "선택하여 붙여넣기 > 수식만": "F",
  "선택하여 붙여넣기 > 순서 바꾸기": "E",
  "선택하여 붙여넣기 > 열 너비만": "W",
  "선택하여 붙여넣기 > 조건부 서식만": "C",
  "선택하여 붙여넣기 > 테두리만 제외하고 모두": "B",
  "셀 > 셀을 삽입하고 기존 셀을 아래로 이동": "D",
  "셀 > 셀을 삽입하고 기존 셀을 오른쪽으로 이동": "I",
  "수정 > 복사": "C",
  "수정 > 붙여넣기": "P",
  "수정 > 삭제": "D",
  "수정 > 선택하여 붙여넣기": "S",
  "수정 > 실행취소": "U",
  "수정 > 이동": "M",
  "수정 > 잘라내기": "T",
  "수정 > 재실행": "R",
  "수정 > 찾기 및 바꾸기": "F",
  "숫자 > 24시간": "U",
  "숫자 > 날짜 시간": "I",
  "숫자 > 날짜": "D",
  "숫자 > 맞춤 날짜 및 시간": "H",
  "숫자 > 맞춤 숫자 형식": "B",
  "숫자 > 맞춤 통화": "E",
  "숫자 > 숫자": "N",
  "숫자 > 시간": "T",
  "숫자 > 일반 텍스트": "X",
  "숫자 > 자동": "M",
  "숫자 > 재무": "F",
  "숫자 > 지수": "S",
  "숫자 > 통화 반올림됨": "R",
  "숫자 > 통화": "C",
  "숫자 > 퍼센트": "P",
  "숫자 > 회계": "A",
  "스마트 칩 > 기본": "D",
  "스마트 칩 > 등급": "8",
  "스마트 칩 > 사용자": "E",
  "스마트 칩 > 성, 이름": "L",
  "스마트 칩 > 이메일 주소": "E",
  "스마트 칩 > 장소": "P",
  "스마트 칩 > 캘린더 일정": "C",
  "스마트 칩 > 파일": "F",
  "시트 정렬 > A열을 기준으로 시트 정렬(내림차순)": "Z",
  "알림 설정 > 댓글 알림": "C",
  "알림 설정 > 수정 알림": "E",
  "열 > 오른쪽에 열 1개 삽입": "O",
  "열 > 왼쪽에 열 1개 삽입": "C",
  "이메일 > 공동작업자에게 이메일 보내기": "E",
  "이메일 > 이메일로 파일 보내기": "A",
  "이미지 > 셀 내에 이미지 삽입": "I",
  "이미지 > 이미지 생성": "Z",
  "이미지 > 이미지를 셀 위에 삽입": "A",
  "정렬 > 가운데": "C",
  "정렬 > 아래": "B",
  "정렬 > 오른쪽": "R",
  "정렬 > 왼쪽": "L",
  "정렬 > 위": "T",
  "정렬 > 중간": "M",
  "줄바꿈 > 오버플로우": "O",
  "줄바꿈 > 자르기": "C",
  "줄바꿈 > 줄바꿈": "W",
  "추천 컨트롤 > 드롭다운 칩 제안 사용 설정": "D",
  "추천 컨트롤 > 수식 수정 사용": "V",
  "추천 컨트롤 > 수식 추천 사용": "W",
  "추천 컨트롤 > 스마트 사용자 칩 제안 사용 설정": "L",
  "추천 컨트롤 > 이름이 지정된 함수 제안 사용": "Q",
  "추천 컨트롤 > 자동완성 사용": "A",
  "텍스트 > 굵게": "B",
  "텍스트 > 기울임": "I",
  "텍스트 > 밑줄": "U",
  "텍스트 > 취소선": "K",
  "파일 > Drive에 바로가기 추가": ",",
  "파일 > T-Box에 바로가기 추가": ",",
  "파일 > 가져오기": "I",
  "파일 > 공유": "S",
  "파일 > 다운로드": "D",
  "파일 > 버전 기록": "H",
  "파일 > 보안 제한사항": "Y",
  "파일 > 사본 만들기": "C",
  "파일 > 새 문서": "N",
  "파일 > 설정": "G",
  "파일 > 세부정보": "B",
  "파일 > 열기": "O",
  "파일 > 오프라인 사용 설정": "K",
  "파일 > 이동": "M",
  "파일 > 이름 바꾸기": "R",
  "파일 > 이메일": "E",
  "파일 > 인쇄": "P",
  "파일 > 휴지통으로 이동": "T",
  "표시 > 격자선": "G",
  "표시 > 보호된 범위": "P",
  "표시 > 수식 바": "F",
  "표시 > 수식": "A",
  "함수 > AI": "G",
  "함수 > 자세히 알아보기": "L",
  "행 > 아래에 행 1개 삽입": "B",
  "행 > 위에 행 1개 삽입": "R",
  "확대/축소 > 100%": "4",
  "확대/축소 > 150%": "6",
  "확대/축소 > 200%": "7",
  "확대/축소 > 50%": "1",
  "확대/축소 > 75%": "2",
  "확대/축소 > 90%": "3",
  "확장 프로그램 > Apps Script": "E",
  "확장 프로그램 > 데이터 스튜디오": "L",
  "확장 프로그램 > 매크로": "M",
  "확장 프로그램 > 부가기능": "A",
  "환경설정 > 데이터 분석 추천 사용 설정": "D",
  "환경설정 > 표 추천 사용 설정": "T",
  "회전 > 맞춤 각도": "C",
  "회전 > 세로로 쌓기": "V",
  "회전 > 아래로 기울이기": "W",
  "회전 > 아래로 회전": "D",
  "회전 > 없음": "N",
  "회전 > 위로 기울이기": "P",
  "회전 > 위로 회전": "U",
};
